import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 22C7EA3A-483D-4BFD-A115-42F86F164135
 * name distribute-horizontal-left
 * version: 4.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/distribute-horizontal-left.svg
 * tags
 */
export const DistributeHorizontalLeftIcon = createSvgIcon(<><path d="M21 7V17H16V22H14V2H16V7H21M5 2H3V22H5V19H10V5H5V2Z" /></>, 'DistributeHorizontalLeftIcon');
export default DistributeHorizontalLeftIcon